import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PUBLIC_API } from 'utils/globalApiServices';
import { toastFlashMessage } from 'utils';

const mutationFn = async ({ token, url_video, response_uuid, session_uuid }) => {
  const url = `public/${token}/roleplay/${response_uuid}/scenario/update/`;
  const { data } = await PUBLIC_API.post(url, { url_video, session_uuid });
  return data;
};

const useUpdatePublicScenarioMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: (response, data) => {
      toastFlashMessage(response?.message, 'success');
      queryClient.invalidateQueries(['REALPLAY_PUBLIC_INFO', data.token]);
    },
  });
};

export default useUpdatePublicScenarioMutation;
